function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useTranslation from "../../../utils/hooks/translation";
// https://dev.to/sandra_lewis/building-a-multi-range-slider-in-react-from-scratch-4dl1

var RangeSlider = function RangeSlider(_ref) {
  var min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    onChange = _ref.onChange,
    unit = _ref.unit,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue;
  var t = useTranslation();
  var _useState = useState(minValue),
    _useState2 = _slicedToArray(_useState, 2),
    minVal = _useState2[0],
    setMinVal = _useState2[1];
  var _useState3 = useState(maxValue),
    _useState4 = _slicedToArray(_useState3, 2),
    maxVal = _useState4[0],
    setMaxVal = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    inputMaxVal = _useState6[0],
    setInputMaxVal = _useState6[1];
  var minValRef = useRef(null);
  var maxValRef = useRef(null);
  var range = useRef(null);
  var enterMax = t('enterMax') || 'Ange max';
  var enterMin = t('enterMin') || 'Ange min';

  // Convert to percentage
  var getPercent = useCallback(function (value) {
    return Math.round((value - min) / (max - min) * 100);
  }, [min, max]);

  // Update minVal and maxVal when changing facets.
  useEffect(function () {
    setMinVal(minValue);
    setMaxVal(maxValue);
    setInputMaxVal(maxValue);
    if (maxValue < max) {
      setInputMaxVal(maxValue);
    }
  }, [minValue, maxValue]);

  // Set width of the range to decrease from the left side
  useEffect(function () {
    if (maxValRef.current) {
      var minPercent = getPercent(minVal);
      var maxPercent = getPercent(+maxValRef.current.value); // Preceding with '+' converts the value from type string to type number

      if (range.current) {
        range.current.style.left = "".concat(minPercent < 0 ? 0 : minPercent, "%");
        range.current.style.width = "".concat(maxPercent - minPercent, "%");
      }
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(function () {
    if (minValRef.current) {
      var minPercent = getPercent(+minValRef.current.value);
      var maxPercent = getPercent(maxVal);
      if (range.current) {
        range.current.style.width = "".concat(maxPercent - minPercent, "%");
      }
    }
  }, [maxVal, getPercent]);
  var onChangeMinValue = function onChangeMinValue(e) {
    var newVal = Number(e.target.value);
    if (newVal <= maxVal && (newVal && newVal >= 0 || e.target.value === '0')) {
      setMinVal(Number(e.target.value));
      onChange({
        min: Number(e.target.value),
        max: maxVal
      });
    }
    if (e.target.value === '') {
      setMinVal(0);
      onChange({
        min: 0,
        max: maxVal
      });
    }
  };
  var onChangeMaxValue = function onChangeMaxValue(e) {
    var maxNumberValue = 100000000; // 100 million should be enough.
    var newVal = Number(e.target.value);
    if (newVal > max) return;
    if (newVal === max) {
      setMaxVal(newVal);
      setInputMaxVal('');
      onChange({
        min: minVal,
        max: max
      });
      return;
    }
    if (newVal >= minVal && (newVal && newVal >= 0 || e.target.value === '0')) {
      setMaxVal(newVal);
      setInputMaxVal(newVal);
      onChange({
        min: minVal,
        max: Number(e.target.value)
      });
    }
    if (e.target.value === '') {
      setMaxVal(max);
      setInputMaxVal('');
      onChange({
        min: minVal,
        max: max
      });
    }
    if (newVal >= maxNumberValue) {
      setMaxVal(maxNumberValue);
      setInputMaxVal(maxNumberValue);
      onChange({
        min: minVal,
        max: maxNumberValue
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "h-range__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group h-range__input"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: minValue,
    className: "form-control form-control-sm text-center",
    placeholder: "".concat(enterMin, " ").concat(unit),
    onChange: function onChange(e) {
      return onChangeMinValue(e);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "h-range__input-divider"
  }, /*#__PURE__*/React.createElement("span", null)), /*#__PURE__*/React.createElement("div", {
    className: "form-group h-range__input"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: inputMaxVal,
    className: "form-control form-control-sm text-center",
    placeholder: "".concat(enterMax, " ").concat(unit),
    onChange: function onChange(e) {
      return onChangeMaxValue(e);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "h-range"
  }, /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: min,
    max: max,
    value: minValue !== '' ? minValue : min,
    step: step,
    ref: minValRef,
    onChange: function onChange(event) {
      var value = Math.min(+event.target.value, maxVal - 1);
      setMinVal(value);
      onChangeMinValue(event);
      event.target.value = value.toString();
    },
    className: "thumb thumb__zindex-3 ".concat(minVal > max - 100 && 'thumb__zindex-5')
  }), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: min,
    max: max,
    value: maxValue !== '' ? maxValue : max,
    step: step,
    ref: maxValRef,
    onChange: function onChange(event) {
      var value = Math.max(+event.target.value, minVal + 1);
      setMaxVal(value);
      onChangeMaxValue(event);
      event.target.value = value.toString();
    },
    className: "thumb thumb__zindex-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slider__track"
  }), /*#__PURE__*/React.createElement("div", {
    ref: range,
    className: "slider__range"
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider__left-value"
  }, min), /*#__PURE__*/React.createElement("div", {
    className: "slider__right-value"
  }, max, " +"))));
};
export default RangeSlider;